import { render } from "./BoardSpace.vue?vue&type=template&id=4db5b20c&ts=true"
import script from "./BoardSpace.vue?vue&type=script&lang=ts"
export * from "./BoardSpace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__